webpackJsonp([88173770026806],{

/***/ 837:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(685);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Container = __webpack_require__(671);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Footer = __webpack_require__(657);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _SiteConfig = __webpack_require__(9);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _testimonialsModule = __webpack_require__(941);
	
	var _testimonialsModule2 = _interopRequireDefault(_testimonialsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Testimonials = function Testimonials() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container about-container' },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Testimonials | ' + _SiteConfig2.default.siteTitle }),
	    _react2.default.createElement(
	      _Header2.default,
	      null,
	      'Testimonials'
	    ),
	    _react2.default.createElement(
	      _Container2.default,
	      { text: true },
	      _react2.default.createElement(
	        'div',
	        { className: _testimonialsModule2.default.container },
	        _react2.default.createElement(
	          'figure',
	          { className: _testimonialsModule2.default.quote },
	          _react2.default.createElement(
	            'blockquote',
	            null,
	            'Rachael worked with us on a number of content projects and was instrumental in turning academic jargon into copy that was relatable. Rachael always advocated for a user-first approach, asking for student feedback and input in new website pages. She worked closely with our internal team including a UX designer and contributed significantly to discussions and workshops. She was quick to respond and detailed in her questions and feedback, showing how much care and effort she put into each task.'
	          ),
	          _react2.default.createElement(
	            'figcaption',
	            null,
	            '\u2014 Bex Taylor, Marketing Manager at',
	            ' ',
	            _react2.default.createElement(
	              'cite',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://themindlab.com', target: '_blank', rel: 'noopener' },
	                'The Mind Lab/Tech Futures Lab'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'figure',
	          { className: _testimonialsModule2.default.quote },
	          _react2.default.createElement(
	            'blockquote',
	            null,
	            'Highly recommend Rachael \u2013 she is switched on and great to work with, intuitively understood what we were trying to achieve and quickly created interesting and engaging content \u2013 which was quite the achievement with the raw material she had to work with!'
	          ),
	          _react2.default.createElement(
	            'figcaption',
	            null,
	            '\u2014 Mike Carroll, Founder and Principal Consultant at',
	            ' ',
	            _react2.default.createElement(
	              'cite',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://mytechies.nz', target: '_blank', rel: 'noopener' },
	                'MyTechies'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'figure',
	          { className: _testimonialsModule2.default.quote },
	          _react2.default.createElement(
	            'blockquote',
	            null,
	            'Rachael is exceptional at developing copy! She turns my vague bullet points or conversations into compelling and engaging copy that converts my customers and keeps them coming back. Rachael has helped me write product descriptions, blog articles, email newsletters, press releases and even formal emails! She is extremely organised, excellent at communicating, always delivers with enough time to review. I would strongly recommend Rachael for any of your copywriting needs and I would be more than happy to answer any questions you may have about Rachael or her work.'
	          ),
	          _react2.default.createElement(
	            'figcaption',
	            null,
	            '\u2014 Tamarin Vermeer, Owner and Creator of',
	            ' ',
	            _react2.default.createElement(
	              'cite',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://bettertea.co', target: '_blank', rel: 'noopener' },
	                'Better Tea Co.'
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	exports.default = Testimonials;
	module.exports = exports['default'];

/***/ }),

/***/ 941:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-pages----testimonials-module---container---3ILd-","quote":"src-pages----testimonials-module---quote---18vDU"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-testimonials-jsx-d2f533b4440b085c0052.js